import React from "react";
import "./IconButton.css";

/**
 * Design-system IconButton.
 *
 * @param {string} label  REQUIRED accessible name (aria-label)
 * @param {"sm"|"md"} size  sm = 26px, md = 34px
 * @param {"default"|"danger"|"action"} tone
 */
const IconButton = React.forwardRef(function IconButton(
  { label, size = "sm", tone = "default", className = "", children, type = "button", ...rest },
  ref,
) {
  const classes = [
    "kc-icon-button",
    `kc-icon-button--${size}`,
    tone !== "default" ? `kc-icon-button--${tone}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button ref={ref} type={type} aria-label={label} title={label} className={classes} {...rest}>
      {children}
    </button>
  );
});

export default IconButton;
